import { BaseGetRequest } from './core/baseGetRequest';
import { BrokerDetails, BrokerDetailsDynamicType } from 'acscp/api/models/brokerDetails';
import { Authentication } from './core/baseRequest';

export class BrokerDetailsForBookingRequest extends BaseGetRequest<BrokerDetails> {
    constructor(public id: string) {
        super(`broker-details/for-booking/${id}`, {}, BrokerDetailsDynamicType, Authentication.SharingToken);
    }
}
